module.exports = __webpack_public_path__ + "media/assets/no-comment-bcc925773a504f1d7b9c3373e7aef959.svg";